import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { partnerStyle } from '@components/partner/config';
import { Partner, PartnerStyle } from '@components/partner/model';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { ColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-partner',
  imports: [TitleComponent, ButtonComponent, NgTemplateOutlet, ImageComponent, ColorPipe],
  templateUrl: './partner.component.html',
  styleUrl: './partner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerComponent implements OnInit {
  @Input() data!: Partner;

  title = signal<Title>(null!);
  style = signal<PartnerStyle>(null!);

  ngOnInit(): void {
    this.style.set(partnerStyle[this.data.theme ?? 'BLUE']!);
    this.title.set({
      size: {
        desktop: 'H3',
        mobile: 'H2',
      },
      text: this.data.title,
      align: {
        mobile: 'CENTER',
        desktop: 'CENTER',
      },
      level: 'SPAN',
      color: this.style().textColor,
    });
  }
}
